import React from 'react';
import { Icon } from '../icon/Icon';
import './Chip.scss';

interface ChipProps {
  disabled?: boolean;
  icon?: string;
  label: string;
  handleRemoveChip?: () => void;
}

export const Chip: React.FC<ChipProps> = ({
  disabled,
  icon,
  label,
  handleRemoveChip
}) => {
  const handleRemove = () => {
    try {
      if (handleRemoveChip) {
        handleRemoveChip();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    try {
      if (e.key === ' ') {
        handleRemove();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <button
      className={`ads-chip ${handleRemoveChip ? 'ads-chip__close' : ''} ${
        icon ? 'ads-chip__icon' : ''
      } ${disabled ? 'ads-chip__disabled' : ''}`}
      tabIndex={disabled ? -1 : 0}
      aria-disabled={disabled && true}
      aria-label={`remove ${label} filter`}
      data-testid="ads-chip"
      onKeyDown={(e) => handleKeyDown(e)}
      onClick={handleRemoveChip && handleRemove}
    >
      {icon && (
        <span className="ads-chip__with-icon">
          {disabled ? (
            <Icon name={icon} color="ads-color-disabled" />
          ) : (
            <Icon name={icon} data-testid="ads-chip__icon" />
          )}
        </span>
      )}
      {label}
      {handleRemoveChip && (
        <span className="ads-chip__close-button">
          {disabled ? (
            <Icon name="closeSm" color="ads-color-disabled" />
          ) : (
            <Icon name="closeSm" />
          )}
        </span>
      )}
    </button>
  );
};
